import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseType } from 'src_common/common/universe';
import { universeModule as akbets } from './universes/akbets/akbets';
import { universeModule as bresbet } from './universes/bresbet/bresbet';
import { universeModule as energy } from './universes/energy/energy';
import { universeModule as gentlemanjim } from './universes/gentlemanjim/gentlemanjim';
import { universeModule as mcbookie } from './universes/mcbookie/mcbookie';
import { universeModule as planetsportbet } from './universes/planetsportbet/planetsportbet';
import { universeModule as star } from './universes/star/star';
import { universeModule as dragonbet } from './universes/dragonbet/dragonbet';
import { universeModule as pricedup } from './universes/pricedup/pricedup';
import { universeModule as betwright } from './universes/betwright/betwright';
import { universeModule as bestodds } from './universes/bestodds/bestodds';
import { universeModule as londonbet } from './universes/londonbet/londonbet';
import { universeModule as betstgeorge } from './universes/betstgeorge/betstgeorge';
import { universeModule as properbet } from './universes/properbet/properbet';
import { UniverseModuleType } from './universes.type';
import { useAppStateContext } from 'src/AppState/AppState';
import { getFeatures } from './features';
import { Common } from 'src/AppState/Common';

const imports: Record<UniverseType, UniverseModuleType> = {
    akbets,
    bresbet,
    dragonbet,
    energy,
    londonbet,
    mcbookie,
    planetsportbet,
    star,
    gentlemanjim,
    pricedup,
    betwright,
    bestodds,
    betstgeorge,
    properbet,
};

export const getUniverseModule = (common: Common): UniverseModuleType => {
    const universe = common.appEnvParams.universe_theme;
    const isProdMode = common.appEnvParams.isProdMode;

    const module = imports[universe];
    return {
        ...module,
        features: getFeatures(universe, isProdMode),
    };
};

interface UniverseComponentPropsType {
    children: (UniverseModule: Omit<UniverseModuleType, 'features' | 'themeColors'>) => React.ReactElement;
}

export const UniverseComponent = observer('UniverseComponent', ({ children }: UniverseComponentPropsType) => {
    const { universeModule } = useAppStateContext();

    const InnerComponent = (): React.ReactElement => {
        return children(universeModule);
    };

    return (
        <React.Suspense fallback={null}>
            <InnerComponent />
        </React.Suspense>
    );
});
